import { Action, createAction, handleActions } from 'redux-actions';
import axios from 'axios';

import { FULFILLED } from './action-type.util';
import { getAxiosData, SERVER_API_URL } from '../config/constants';
import { ACTION_TYPES as ACTION_AUTH } from './authentication';

export const ACTION_TYPES = {
    UPDATE_STATE: 'config/UPDATE_STATE',
    GET_VERSION_INFO: 'config/GET_VERSION_INFO',
};

export interface IConfigState {
    loading: boolean;
    error: any;
    versionBE: string;
}

const initialState = {
    loading: false,
    error: null, // Errors returned from server side
    versionBE: '',
};

export const updateConfigState = createAction(ACTION_TYPES.UPDATE_STATE);

export const getVersionInfo = createAction(ACTION_TYPES.GET_VERSION_INFO, () =>
    getAxiosData(
        axios.get(`${SERVER_API_URL}/version-info`, {
            headers: { 'Content-Type': 'text/html', SkipError: true },
        }),
    ),
);

/* Reducer function */
/*const onPending = (state: IConfigState): IConfigState => ({ ...state, loading: true });
const onRejected = (state: IConfigState, action: Action<any>): IConfigState => ({
    ...state,
    error: getRejectedRespData(action.payload),
    loading: false,
});*/
/* Reducer function end */

export default handleActions<IConfigState, any>(
    {
        [FULFILLED(ACTION_AUTH.LOGOUT)]: (): IConfigState => ({
            ...initialState,
        }),
        [ACTION_TYPES.UPDATE_STATE]: (state: IConfigState, action: Action<any>): IConfigState => ({
            ...state,
            ...action.payload,
        }),

        [FULFILLED(ACTION_TYPES.GET_VERSION_INFO)]: (state: IConfigState, action: Action<string>): IConfigState => ({
            ...state,
            versionBE: action.payload,
        }),

        /* WS events */
        /* WS events end */
    },
    initialState,
);
